import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const ScriptTag = ({ dangerouslySetInnerHTML: innerHtml, ...otherProps }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');
    Object.entries(otherProps).forEach(([key, value]) => {
      if (key === 'children') return;

      script[key] = value;
    });

    if (!script.type) script.type = 'text/javascript';
    if (innerHtml) script.text = innerHtml.__html;

    wrapperRef.current.appendChild(script);
  });

  return <span ref={wrapperRef} />;
};

ScriptTag.propTypes = {
  dangerouslySetInnerHTML: PropTypes.object
};

ScriptTag.defaultProps = {
  dangerouslySetInnerHTML: null
};

export default ScriptTag;
